var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsterisk = function SvgAsterisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#asterisk_svg__a)",
    fillRule: "evenodd",
    d: "M96-10H64v41.373L34.745 2.118 12.118 24.745 41.373 54H0v32h41.373l-29.255 29.255 22.627 22.628L64 108.628V150h32v-41.373l29.255 29.255 22.627-22.627L118.627 86H160V54h-41.372l29.254-29.254-22.627-22.628L96 31.373z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "asterisk_svg__a",
    x1: 0,
    x2: 160,
    y1: -10,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004EFF"
  })))));
};
export default SvgAsterisk;